import React, { useState } from 'react';
import './Services.css';
import { 
  FaLaptopCode, 
  FaCogs, 
  FaHeadset, 
  FaShieldAlt,
  FaNetworkWired,
  FaCloud,
  FaProjectDiagram,
  FaLightbulb
} from 'react-icons/fa';
import digitalizacao from '../../img/digitalizacao.png';
import desenvolvimento from '../../img/desenvolvimento-de-websites.png';
import consultoria1 from '../../img/consultoria.jpg';
import seguranca1 from '../../img/cybersecurity.jpg';
import software2 from '../../img/help.png';
import consultoria2 from '../../img/consultoria.jpg';
import project from '../../img/project.jpg';

const Services = ({ limit } ) => {
  const [expandedBenefits, setExpandedBenefits] = useState({});
  const services = [
    {
      title: "Digitalização de Processos",
      icon: <FaLightbulb />,
      image: digitalizacao,
      description: "Transforme tarefas manuais em fluxos de trabalho inteligentes.",
      benefits: [
        "Redução de até 70% no tempo de execução",
        "Eliminação de erros manuais",
        "Relatórios automáticos em tempo real",
        "Integração com sistemas existentes"
      ],
      details: (<> A Infosfera digitaliza e automatiza processos com <strong>qualidade e precisão,</strong> reduzindo custos e aumentando a eficiência — sempre com <strong>responsabilidade e segurança</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
           </> )
      },
    {
      title: "Desenvolvimento de Software sob Medida",
      icon: <FaLaptopCode />,
      image: desenvolvimento,
      description: "Soluções que falam a língua do seu negócio.",
      benefits: [
        "Desenvolvimento ágil e iterativo",
        "Testes automatizados de qualidade",
        "Documentação completa do projeto",
        "Suporte pós-implantação"
      ],
      details:(<> Criamos aplicações personalizadas para atender às suas necessidades específicas, garantindo <strong>qualidade no código, confiabilidade no desempenho e resultados que superam expectativas</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
     </> ) 
    },
    {
      title: "Consultoria em TI",
      icon: <FaHeadset />,
      image: consultoria1,
      description: "Estratégia e tecnologia lado a lado.",
      benefits: [
        "Análise completa do ambiente tecnológico",
        "Plano estratégico personalizado",
        "Recomendações baseadas em melhores práticas",
        "Acompanhamento na implementação"
      ],
      details: (<> Oferecemos análises, recomendações e planos personalizados para impulsionar o crescimento da sua empresa com <strong>responsabilidade técnica e soluções confiáveis.</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
        </> ) 
    },
    {
      title: "Cibersegurança",
      icon: <FaShieldAlt />,
      image: seguranca1,
      description: "A sua informação, protegida 24/7.",
      benefits: [
        "Proteção contra malware e ransomware",
        "Monitoramento de segurança 24/7",
        "Backup e recuperação de desastres",
        "Conformidade com LGPD e outras normas"
      ],
      details:(<> Implementamos políticas e tecnologias que blindam os seus dados contra ameaças, garantindo <strong>confiança, conformidade e tranquilidade para o seu negócio</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> )  
    
      },
    {
      title: "Help Desk em IT",
      icon: <FaCogs />,
      image: software2,
      description: "Mais do que suporte, parceria contínua.",
      benefits: [
        "Atendimento rápido e eficaz",
        "Suporte técnico especializado",
        "Manutenção preventiva regular",
        "Resolução de problemas 24/7"
      ],
      details: (<> Mantemos a sua infraestrutura sempre atualizada e funcional, com atendimento rápido e eficaz, priorizando <strong>qualidade, responsabilidade e satisfação do cliente</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> ) 
      },
    {
      title: "Desenho e Implementação de Projetos Informáticos",
      icon: <FaProjectDiagram />,
            image: project,

      description: "Do papel à realidade, com excelência.",
      benefits: [
        "Planejamento e design detalhado",
        "Gerenciamento de projeto rigoroso",
        "Execução com prazos cumpridos",
        "Testes completos e validação"
      ],
      details: (<> Planeamos e executamos projetos de TI de ponta a ponta, com <strong>rigor técnico, prazos cumpridos e resultados confiáveis</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> ) 
      },
    {
      title: "Computação em Nuvem",
      icon: <FaCloud />,
      description: "Flexibilidade e segurança para o seu negócio.",
      benefits: [
        "Acesso seguro e confiável",
        "Alta disponibilidade garantida",
        "Escalabilidade sob demanda",
        "Backup automático e recuperação"
      ],
      details: (<> Migramos e gerimos os seus serviços na nuvem, oferecendo <strong>acesso seguro, alta disponibilidade e total confiabilidade.</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> ) 
      },
  //   {
  //     title: "Virtualização",
  //     icon: <FaServer />,
  //     description: "Mais eficiência, menos custos.",
  //     details:  (<> Consolidamos servidores e ambientes virtuais para otimizar recursos, reduzir gastos e garantir <strong>desempenho confiável com máxima segurança.</strong> <a href="/servicos" className="saber-mais-link">Saber Mais</a>
  //  </> )
  //     },
    {
      title: "Infraestrutura de Rede  de Computadores",
      icon: <FaNetworkWired />,
      image: consultoria2,
      description: "A base sólida para a sua transformação digital.",
      benefits: [
        "Cablagem estruturada de alta qualidade",
        "Conexões seguras e estáveis",
        "Alto desempenho e confiabilidade",
        "Manutenção técnica contínua"
      ],
      details: (<> Projetamos, instalamos e otimizamos redes de computadores com cablagem estruturada de alta qualidade, garantindo conexões seguras, estáveis e de alto desempenho. Cada projeto é executado com responsabilidade técnica, rigor nos prazos e foco total na confiança e satisfação do cliente — desde a infraestrutura física até à configuração e manutenção da rede. <a href="/servicos" className="saber-mais-link">Saber Mais</a>
    </> )
      }
  ];

  const display = typeof limit === 'number' ? services.slice(0, limit) : services;

  return (
    <div id="servicos-section" className="services-container">
      <div className="services-grid">
        {display.map((service, index) => (
          <div className="service-card" key={index}>
            {service.image && (
              <div className="service-image-container">
                <img src={service.image} alt={service.title} className="service-image" />
              </div>
            )}
            <div className="service-card-content">
              <div className="service-header">
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-name">{service.title}</h3>
              </div>
              <p className="service-description">{service.description}</p>
              <div className="service-details">{service.details}</div>
              {service.benefits && service.benefits.length > 0 && (
                <div className="service-benefits">
                  <h4 className="benefits-title">Benefícios:</h4>
                  <ul className="benefits-list">
                    {(expandedBenefits[index] ? service.benefits : service.benefits.slice(0, 3)).map((benefit, bidx) => (
                      <li key={bidx}>{benefit}</li>
                    ))}
                  </ul>
                  {service.benefits.length > 3 && (
                    <button 
                      className="toggle-benefits-btn"
                      onClick={() => setExpandedBenefits(prev => ({ ...prev, [index]: !prev[index] }))}
                    >
                      {expandedBenefits[index] ? 'Ver Menos' : 'Ver Mais'}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {typeof limit === 'number' && limit < services.length && (
        <div className="services-footer">
          <a href="/servicos" className="btn-ver-todos">Ver todos os serviços</a>
        </div>
      )}
    </div>
  );
};

export default Services;